export default {
  isLogin: false,
  isListeningAccount: false,
  socket: undefined
}
